import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Spinner } from '@/shared/ui';

export function AuthLayout() {
  return (
    <main className="min-h-dvh bg-neutral-50">
      <div className="mx-auto w-full min-h-dvh grid xl:[grid-template-columns:1220fr_700fr]">
        <section className="relative hidden xl:block bg-neutral-100">
          <img
            alt="banner"
            className="object-cover w-full h-full absolute inset-0"
            src="/assets/auth/banner.png"
          />
          <img
            alt="동구바이오제약"
            className="absolute top-[50px] left-[50px]"
            height={30}
            src="/assets/auth/dk-logo.svg"
            width={316}
          />
        </section>

        <section className="flex items-center justify-center p-6">
          <Suspense fallback={<Spinner size="lg" />}>
            <Outlet />
          </Suspense>
        </section>
      </div>
    </main>
  );
}
